import { _headers, _headers_with_token } from '../constants/headers';
import { isEmptyJSON } from '../functions/ValidationState';

export const getHeader = (typeHeader) => {

   if ( typeHeader === 1 ) {
     return _headers();
   } else if ( typeHeader === 2 || typeHeader === 3 ) {
     return _headers_with_token();
   }
 }

export const getResponse = ( data, resolve, reject ) => {
   switch( data.response ) {
 
     case 'Forbidden':
       reject(data);
     break;
 
     case 'without permission':
       reject(data);
     break;
 
     case 'success':
       resolve(data);
     break;
 
     case 'Invalid Token':
       reject(data);
     break;
 
     case 'error':
       reject(data);
     break;
 
     case 'Unauthorized':
       reject(data);
     break;
 
     case 'Not Found':
       resolve(data);
     break;
 
     case 'Duplicate':
       reject(data);
     break;
 
     case 'without changes':
       reject(data);
     break;
 
     case 'Bad Request':
       reject(data);
     break;
 
     case 'Token Valid':
       resolve(data);
     break;
 
     case 'TokenExpiredError':
       reject(data);
     break;
 
     default:
       resolve({ response: 'without response', message: `There's no answer` });
     break;
   }
 }
 
 export const actions_requests = ( body, url_request, method, typeHeader = null ) => {
   let headers = getHeader(typeHeader);
 
   return new Promise( ( resolve, reject ) => {
     fetch(url_request, {
       method,
       headers,
       body
     })
     .then( response => typeHeader === 3 ? response.blob() : response.json() )
     .then( data => {
 
       if ( data.response === undefined ) {
         if ( isEmptyJSON(data) === true ) {
           resolve(data);
         }
       } else {
         getResponse( data, resolve, reject );
       }
       
     });
   });
 }
 